import { AXIS_IDS, COND_IDS, FORK_IDS, LIKERT_OPTIONS, N_LIKERT, OFFSET_COND, OFFSET_FORK, OFFSET_SELF, OFFSET_WANT, QUESTIONS, SELF_IDS, TOTAL_QUESTIONS, WANT_IDS, } from './questions.js';
export function emptyAnswers() {
    return new Array(TOTAL_QUESTIONS).fill(null);
}
function asNumber(value) {
    return typeof value === 'number' && Number.isFinite(value) ? value : null;
}
/**
 * Оси считаются как среднее по пяти пунктам, нормированное в 0..100.
 * Обратные пункты переворачиваются: 5 становится 1.
 * Неотвеченная ось даёт 50 — середину, а не ноль.
 */
export function scoreAxes(answers) {
    const sums = {};
    for (const id of AXIS_IDS)
        sums[id] = { sum: 0, n: 0 };
    for (let i = 0; i < N_LIKERT; i++) {
        const q = QUESTIONS[i];
        const raw = asNumber(answers[i] ?? null);
        if (raw === null)
            continue;
        const value = q.reverse ? LIKERT_OPTIONS + 1 - raw : raw;
        const bucket = sums[q.axis];
        bucket.sum += value;
        bucket.n += 1;
    }
    const out = {};
    for (const id of AXIS_IDS) {
        const { sum, n } = sums[id];
        out[id] = n === 0 ? 50 : Math.round(((sum / n - 1) / (LIKERT_OPTIONS - 1)) * 100);
    }
    return out;
}
export function band(value) {
    if (value >= 65)
        return 'hi';
    if (value <= 35)
        return 'lo';
    return 'mid';
}
/** Уровень важности условия: 1 — принципиально, 2 — важно, 3 — желательно. */
export function condLevel(answers, cond) {
    const i = COND_IDS.indexOf(cond);
    return i < 0 ? null : asNumber(answers[OFFSET_COND + i] ?? null);
}
export function forkChoice(answers, fork) {
    const i = FORK_IDS.indexOf(fork);
    return i < 0 ? null : asNumber(answers[OFFSET_FORK + i] ?? null);
}
export function selfNumber(answers, key) {
    const i = SELF_IDS.indexOf(key);
    return i < 0 ? null : asNumber(answers[OFFSET_SELF + i] ?? null);
}
export function selfText(answers, key) {
    const i = SELF_IDS.indexOf(key);
    const value = i < 0 ? null : answers[OFFSET_SELF + i];
    return typeof value === 'string' ? value.trim() : '';
}
export function wantChoice(answers, key) {
    const i = WANT_IDS.indexOf(key);
    return i < 0 ? null : asNumber(answers[OFFSET_WANT + i] ?? null);
}
export function buildProfile(answers) {
    const condLevels = COND_IDS.map((c) => condLevel(answers, c) ?? 0);
    return {
        axes: scoreAxes(answers),
        age: selfNumber(answers, 'age'),
        city: selfText(answers, 'city'),
        faith: selfNumber(answers, 'faith'),
        lang: selfNumber(answers, 'lang'),
        edu: selfNumber(answers, 'edu'),
        past: selfNumber(answers, 'past'),
        field: selfNumber(answers, 'field'),
        wantFaith: wantChoice(answers, 'faith'),
        wantLang: wantChoice(answers, 'lang'),
        wantAge: wantChoice(answers, 'age'),
        wantEdu: wantChoice(answers, 'edu'),
        wantPast: wantChoice(answers, 'past'),
        wantGeo: wantChoice(answers, 'geo'),
        condLevels,
        forkAnswers: FORK_IDS.map((f) => forkChoice(answers, f) ?? 0),
        stems: COND_IDS.filter((_, i) => condLevels[i] === 1),
    };
}
/** Сколько пунктов заполнено — для прогресса и для проверки завершённости. */
export function answeredCount(answers) {
    return answers.reduce((n, a, i) => {
        const q = QUESTIONS[i];
        if (!q)
            return n;
        if (q.kind === 'text' && q.optional)
            return a === null ? n : n + 1;
        if (a === null || a === '')
            return n;
        return n + 1;
    }, 0);
}
export function isComplete(answers) {
    return QUESTIONS.every((q, i) => {
        const a = answers[i];
        if (q.kind === 'text' && q.optional)
            return a !== undefined;
        return a !== null && a !== undefined && a !== '';
    });
}
//# sourceMappingURL=scoring.js.map